/*
  LOULEX-Anpassung (#60, beim Theme-Update erneut anwenden): Rabattcode im Warenkorb und im Drawer
  (snippets/cart-discount.liquid). Prestiges <cart-discount-field> aus theme.js bleibt zuständig
  für das Einlösen selbst: Es hört auf "change" am Eingabefeld, schickt POST /cart/update.js mit
  allen Codes und meldet cart:refresh (Erfolg) oder cart:discount:error (Fehler).

  Diese Ergänzung sitzt nur davor und daneben:

  1. Enter im Feld löst den Code ein, statt das Warenkorb-Formular abzuschicken. Ohne das landet
     man sofort im Checkout (das Formular hat „Zur Kasse“ als ersten Absende-Button) — genau das,
     was der Warenkorb-Gutschein vermeiden soll.

  2. Der Button „Einlösen“ im Feld löst denselben Weg aus.

  3. Doppelte Anfragen werden verschluckt: Ein Klick auf den Button nimmt dem Feld den Fokus,
     wodurch der Browser bereits "change" auslöst. Gleicher Wert innerhalb von 1,5 s = eine
     Anfrage. Ein späterer zweiter Versuch mit demselben Code läuft dagegen durch.

  4. Nach einer Fehlermeldung fliegt der nicht einlösbare Code wieder aus dem Warenkorb. Prestige
     lässt ihn stehen (cart.discount_codes mit applicable: false); er ginge beim nächsten „Zur
     Kasse“ mit und der Checkout meldete ihn erneut.

  5. Die Fehlermeldung verschwindet, sobald wieder getippt wird. Prestige blendet sie nur ein.

  Nach einem Theme-Update prüfen, ob <cart-discount-field>, das Ereignis cart:discount:error und
  der versteckte Sammel-Input [name="discount"] noch so heißen.
*/
(function () {
  'use strict';

  var FIELD = 'cart-discount-field';
  var APPLY = '.loulex-discount-apply';
  var DOUBLE_SUBMIT_MS = 1500;

  // Feld -> zuletzt abgeschickter Wert samt Zeitpunkt
  var lastSubmit = new WeakMap();

  function fieldOf(node) {
    return node && node.closest ? node.closest(FIELD) : null;
  }

  function inputOf(field) {
    return field ? field.querySelector('input.input') : null;
  }

  function bannerOf(field) {
    var wrapper = field ? field.closest('.cart-discount') : null;
    return wrapper ? wrapper.querySelector('cart-discount-banner') : null;
  }

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function submit(field) {
    var input = inputOf(field);

    if (!input) {
      return;
    }

    input.value = input.value.trim();
    input.blur(); // schließt die Bildschirmtastatur; löst "change" aus, wenn der Wert neu ist
    input.dispatchEvent(new Event('change', { bubbles: true })); // zweiter Versuch mit gleichem Code
  }

  // Vor Prestige (Capture): Wert säubern und die zweite Anfrage desselben Wertes abfangen.
  document.addEventListener(
    'change',
    function (event) {
      var input = event.target;

      if (!input || input.type === 'hidden' || !input.closest) {
        return;
      }

      var field = fieldOf(input);

      if (!field) {
        return;
      }

      input.value = input.value.trim();

      var previous = lastSubmit.get(field);

      if (previous && previous.value === input.value && Date.now() - previous.at < DOUBLE_SUBMIT_MS) {
        event.stopImmediatePropagation();
        return;
      }

      lastSubmit.set(field, { value: input.value, at: Date.now() });
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || event.isComposing) {
      return;
    }

    var field = fieldOf(event.target);

    if (!field || event.target.type === 'hidden') {
      return;
    }

    event.preventDefault(); // sonst schickt Enter das Warenkorb-Formular zur Kasse
    submit(field);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest(APPLY) : null;

    if (!button) {
      return;
    }

    event.preventDefault();
    submit(fieldOf(button));
  });

  document.addEventListener('input', function (event) {
    var field = fieldOf(event.target);

    if (!field) {
      return;
    }

    var banner = bannerOf(field);

    if (banner) {
      banner.hidden = true;
    }
  });

  document.addEventListener('cart:discount:error', function () {
    fetch(routeRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var codes = cart.discount_codes || [];
        var applicable = codes
          .filter(function (entry) {
            return entry.applicable;
          })
          .map(function (entry) {
            return entry.code;
          });

        // Der versteckte Sammel-Input geht mit „Zur Kasse“ mit und darf den Code nicht behalten.
        document.querySelectorAll(FIELD + ' [name="discount"]').forEach(function (hidden) {
          hidden.value = applicable.join(',');
        });

        if (applicable.length === codes.length) {
          return null;
        }

        return fetch(routeRoot() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: applicable.join(',') })
        });
      })
      .catch(function () {
        // Der Warenkorb bleibt, wie er ist; die Fehlermeldung steht bereits im Feld.
      });
  });
})();
